<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 345px;}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 99%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  /deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox" >
      <table>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('type')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.type" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in classifydata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>会议标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入标题" class="input title" @blur="detection(11, 53, form.title)"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>标题图片
          </td>
          <td class="after">
            <el-form-item>
              <el-upload
                v-if="this.$route.path === '/Hyfbgl'"
                :action="url"
                :limit="1"
                ref="uploadPic_img"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess"
                list-type="picture-card"
                :on-remove="handleRemovePicture"
                :before-upload="beforeUploadPicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                v-else
                :action="url"
                :limit="1"
                list-type="picture-card"
                :file-list="fileList_img"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview_icon"
                :on-success="onSuccess"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                :on-remove="handleRemovePicture"
                 @mouseover.native="getPhoUrl"
                :on-exceed="exceed">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('pdf')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>文件上传
          </td>
          <td style="display: flex;">
            <el-upload
              class="upload-demo"
              drag
              :action= url
              :limit="1"
              ref="uploadPic_file"
              :on-success="onFileSuccess"
              :before-upload="beforeUploadFile"
              :on-remove="handleRemoveFile"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPdfUrl"
              multiple><i class="el-icon-upload"></i><div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isContentMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>会议内容
          </td>
          <td class="after">
            <div id="editor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">
            <span v-if="isMandatory('status')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>当前状态
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.status" placeholder="请选择当前状态" class="select level" :popper-append-to-body="false">
                <el-option v-for="item in statusary" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>会议简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.introduce"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">大会议程</td>
          <td class="after" style="display: flex;" v-for="(item, index) in dhycList" :key="index">
            <el-form-item style="margin-right:15px">
              <el-date-picker v-model="item.days" :transfer="true" popper-class='mzindex' type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy 年 MM 月 dd 日"></el-date-picker>
            </el-form-item>
            <el-form-item style="margin-right:15px">
              <el-time-picker is-range popper-class='mzindex' v-model="item.times" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="HH:mm" placeholder="选择时间范围"></el-time-picker>
            </el-form-item>
            <el-form-item style="margin-right:15px">
              <el-input v-model="item.content" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item style="margin-right:15px;height: 36px;">
              <i class="el-icon-circle-plus-outline" style="font-size:34px" @click="getDhycAry"></i>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发布时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker popper-class='mzindex' v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="onAdd" v-if="this.$route.path === '/Hyfbgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/HyfbglUpdate'">确定修改</el-button>
      <el-button type="success" @click="isPass()" v-if="this.$route.path === '/HyfbLook'">通过</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Hyfbgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/HyfbglUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-if="this.$route.path === '/HyfbLook'">不通过</el-button>
      <el-button  @click="backtrackLook()" v-if="this.$route.path === '/HyfbLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 罗志远
 * 线上云展-会议发布
 */
import {mapState} from 'vuex'
// import E from 'wangeditor'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      dhycList: [],
      days: '',
      times: '',
      content: '',
      form: {
        type: '',
        title: '',
        status: '',
        content: '',
        introduce: '',
        addtime: ''
      },
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //状态分类
      statusary: [
        {
          value: '召集中',
          label: '召集中'
        },
        {
          value: '召开中',
          label: '召开中'
        },
        {
          value: '已召开',
          label: '已召开'
        }
      ],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList_img: [{url: ''}],
      examine: '',
      //表名
      tabname: 'dmcn_meetingrelease',
      tabContentname: 'dmcn_meetingrelease_data',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      nodeid: state => state.NavID
    }),
    Url()
    {
      return this.url
    }
  },
  watch:
  {
    nodeid:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(this.nodeid, 'type').then(res =>
        {
          this.classifydata = []
          res.forEach(e => this.classifydata.push({ value: e.dispc, label: e.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    this.getDhycAry()
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    //添加保存
    onAdd()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 53,
        retAtt: 1,
        type: this.form.type,
        title: this.form.title,
        thumb: this.form.thumb,
        pdf: this.form.pdf,
        status: this.form.status,
        introduce: this.form.introduce,
        addtime: (Date.parse(new Date()) / 1000),
        titleThumb: '',
        examine: this.examine
      }
      //添加会议发布
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        //添加会议发布内容
        let params = {
          cmd: 'addWithId',
          _major: 11,
          _minor: 54,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(params).then((res) =>
        {
          if (res.ret === 1)
            this.$message({message: '会议内容未填写', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '会议发布上传成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
        //添加大会议程
        this.addHyrc(ret.id).then(res =>
        {
          if (res.ids.length > 0)
            this.$message({message: '大会议程上传成功', type: 'success', customClass: 'mzindex'})
        })
      })
    },
    //添加会议日程
    addHyrc(catid)
    {
      //添加大会议程
      let parameter = []
      this.dhycList.forEach(e =>
      {
        if (e.content)
          parameter.push({catid: catid, content: e.content, data: e.days, times: `${e.times[0]}-${e.times[1]}`})
      })
      let param = {
        cmd: 'adds',
        _major: 11,
        _minor: 34,
        json: JSON.stringify(parameter)
      }
      return window.post.getPost(param)
    },
    //点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview_icon(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //获取url地址
    getPdfUrl()
    {
      let that = this
      window.public.onUploadFile(that)
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //点击获取大会议程
    getDhycAry()
    {
      this.dhycList.push({days: '', times: '', content: ''})
    },

    isgetData()
    {
      if (this.$route.path === '/HyfbglUpdate')
      {
        this.getData()
        this.getContent()
        this.getHyrc()
      }
      else if (this.$route.path === '/HyfbLook')
      {
        this.getData()
        this.getContent()
        this.getHyrc()
      }
      else if (this.$route.path === '/Hyfbgl')
        return false
    },
    //通过上传列表点击查看
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 53,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.type = ret[0].type
        this.form.title = ret[0].title
        this.form.thumb = ret[0].thumb
        this.form.pdf = ret[0].pdf
        this.form.status = ret[0].status
        this.form.introduce = ret[0].introduce
        this.form.addtime = ret[0].addtime * 1000
        this.fileList_img[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
      })
    },
    //获取上传内容
    getContent()
    {
      let params = {
        cmd: 'query',
        _major: 11,
        _minor: 54,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(params).then(res =>
      {
        this.form.content = res[0].content
        // 重新设置编辑器内容
        this.editor.txt.html(res[0].content)
      })
    },
    //获取会议日程
    getHyrc()
    {
      let params = {
        cmd: 'query',
        _major: 11,
        _minor: 34,
        _exp: `catid = ${this.updataID}`
      }
      window.post.getPost(params).then(res =>
      {
        if (res.length > 0)
          this.dhycList.splice(0, 1)
        res.forEach(e =>
        {
          let times = []
          let time = e.times.split('-')
          times.push(time[0], time[1])
          this.dhycList.push({content: e.content, days: e.data, times})
        })
      })
    },
    //确定修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 53,
        retAtt: 1,
        id: this.updataID,
        type: this.form.type,
        title: this.form.title,
        thumb: this.form.thumb,
        pdf: this.form.pdf,
        status: this.form.status,
        introduce: this.form.introduce,
        addtime: this.form.addtime / 1000,
        titleThumb: ''
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          //内容修改
          this.updaeContent()
          //会议日程修改
          this.modifyHyrc()
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.$router.push({path: '/Hyfbgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //内容修改
    updaeContent()
    {
      let params =
      {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 54,
        retAtt: 1,
        id: this.updataID,
        content: this.form.content
      }
      window.post.getPost(params)
    },
    //会议日程修改
    modifyHyrc()
    {
      let param = {cmd: 'query', _major: 11, _minor: 34, _exp: `catid=${this.updataID}`}
      window.post.getPost(param).then(res =>
      {
        if (res.length > 0)
        {
          this.delHyrc(res).then(ref =>
          {
            this.addHyrc(this.updataID).then(ret =>
            {
              if (ret.ids.length > 0)
                this.$message({message: '大会议程修改成功', type: 'success', customClass: 'mzindex'})
            })
          })
        }
        else
        {
          this.addHyrc(this.updataID).thrn(ret =>
          {
            if (ret.ids.length > 0)
              this.$message({message: '大会议程修改成功', type: 'success', customClass: 'mzindex'})
          })
        }
      })
    },
    //修改会议日程
    delHyrc(ary)
    {
      let cont = {cmd: 'deletes', _major: 11, _minor: 34, ids: `${Array.from(ary, e => e.id).join(',')}`}
      return window.post.getPost(cont)
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Hyfbgl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToExamine'})
      this.$store.commit('onActiveName', '1')
    },
    //不通过
    notPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 53,
        retAtt: 1,
        id: this.updataID,
        examine: 4
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 53, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 53,
        retAtt: 1,
        id: this.updataID,
        examine: examine
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //文件上传之前的钩子
    beforeUploadFile(file)
    {
      let that = this
      window.public.beforeUploadFile(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //pdf文件上载成功
    onFileSuccess(response)
    {
      let that = this
      window.public.onFileSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //删除文件
    handleRemoveFile(fileList)
    {
      let that = this
      window.public.handleRemoveFile(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/xsyz/HyRelease.vue